import React from 'react';
import { Login, LoginForm } from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
//import { Link } from 'react-router-dom'; 

// bg and logo
import logo from './images/imtbike_logo.png';
import bg from './images/bg.png';
import { BF_ROOT } from "./api-config";

const styles = ({
    main: { background: `url(${bg}) repeat !important` },
    avatar: {
        backgroundImage: `url(${logo})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        height: 60,
    },
    "Login-card": {
        background: '#f7f7f7',
    },
    icon: { display: 'none' },
    recoverPassword: {
        margin: '15px',
        textAlign: 'center',
        color: 'orange',
        textDecoration: 'none', 
        '&:hover': {
            textDecoration: 'underline', 
        },
    },
});


const CustomLoginForm = withStyles(styles)(({ classes, ...props }) => (
    <div>
        <LoginForm {...props} />
        <div className={classes.recoverPassword}>
            {/* <Link to="/recover-password" className={classes.recoverPassword}>Forgot your password?</Link> */}
            <a href={`${BF_ROOT}/?forget_password=true`} target="_blank" className={classes.recoverPassword}>
                Forgot your password?
            </a>
        </div>
    </div>
));


const CustomLoginPage = props => (
    <Login
        loginForm={<CustomLoginForm />}
        {...props}
    />
);

export default withStyles(styles)(CustomLoginPage);


// WEBPACK FOOTER //
// ./src/LoginPage.js